export const LOGO_URL = "/dunc-logo.webp";

// WhatsApp — single editable config value
export const WHATSAPP_NUMBER = "919901234981"; // +91 990 1234 981
export const WHATSAPP_DISPLAY = "+91 990 1234 981";
export const WHATSAPP_URL = (message = "Hi DUNC, I'd love to try the First Sip / Founder's Batch.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const INSTAGRAM_URL = "https://www.instagram.com/drinkdunc/";
export const INSTAGRAM_HANDLE = "@drinkdunc";
export const YOUTUBE_URL = "https://www.youtube.com/@DrinkDunc";

export const NAV_LINKS = [
  { label: "DUNC", href: "#meet" },
  { label: "Flavours", href: "#collection" },
  { label: "Formats", href: "#formats" },
  { label: "Our Story", href: "#philosophy" },
  { label: "For Moments", href: "/moments" },
  { label: "Connect", href: "/contact" },
];

// Contextual WhatsApp prefill messages
export const WHATSAPP_MSG = {
  flavour: (name) =>
    `Hi DUNC, I'm interested in the ${name} kombucha — where can I get my hands on it?`,
  moments:
    "Hi DUNC, I'm planning an event and would love to serve DUNC. Can we talk?",
  can: "Hi DUNC, I'd love to know more about the 250 ML cans.",
  bottle: "Hi DUNC, I'd love to know more about the 330 ML bottles.",
};

// ---------- Pre-launch service area helpers ----------
export const BANGALORE_KEYWORDS = [
  "bangalore", "bengaluru", "blr", "bengalooru",
];

// Approximate Bangalore Urban bounding box
export const BANGALORE_BBOX = { minLat: 12.80, maxLat: 13.20, minLng: 77.40, maxLng: 77.85 };

export const isBangaloreCity = (text = "") => {
  const t = String(text).toLowerCase().trim();
  if (!t) return false;
  return BANGALORE_KEYWORDS.some((k) => t.includes(k));
};

export const isBangaloreCoords = (lat, lng) => {
  const b = BANGALORE_BBOX;
  return lat >= b.minLat && lat <= b.maxLat && lng >= b.minLng && lng <= b.maxLng;
};

// Starter Pack — 4 per flavour, derived from the active PRODUCTS list at runtime.
export const STARTER_PACK_QTY_PER_FLAVOUR = 4;
